import { EMAIL_SIGNOL_SUPPORT } from "../../constants/constants";
import { Button, Icon } from "../atoms";

const ErrorApp = ({ title, subtitle, buttonText, icon }) => {
  const reloadPage = () => {
    window.location.href = "/dashboard";
  };

  const signolLogoSrc =
    "https://signol-email-images.s3.eu-west-2.amazonaws.com/SignolLogoWhite.png";

  return (
    <div
      className={`w-full min-h-screen bg-primary-500 bg-gradient-to-br from-primary-500 to-primary-200 flex flex-col justify-center items-center gap-10`}
    >
      <div className="m-auto flex flex-col text-center items-center gap-6">
        <Icon
          name={icon ? icon : "brokenChains"}
          backgroundColor="transparent"
          size={36}
          padding={false}
          textColor="white"
        />
        <img className="h-16 w-48" src={signolLogoSrc} alt="Signol logo" />

        <div>
          <div className="text-lg px-4 text-white">
            Sorry we couldn't load your account.
          </div>
          <div className="text-lg px-4 ">
            <p className="text-lg px-4 text-white">
              Try refreshing the page. If the issue persists, contact
            </p>
            <a
              className="text-primary-800 underline font-bold"
              href={`mailto:${EMAIL_SIGNOL_SUPPORT}?subject=App Loading Issue&body=Error when loading the app.`}
            >
              {EMAIL_SIGNOL_SUPPORT}
            </a>
          </div>
        </div>
        {!!buttonText && (
          <Button textColor="white" padding={false} onClick={reloadPage}>
            <div className="flex justify-center">
              <div className="my-auto">{buttonText}</div>
            </div>
          </Button>
        )}
      </div>
    </div>
  );
};

export default ErrorApp;
